<template>

    <div class="site-main">
        <div>
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
              <el-menu-item v-for="c in classfications" :key="c" :index="c">{{ c }}</el-menu-item>
            </el-menu>
        </div>
        <div class="product-container">
            <div class="product-layout-left">
               
                <div class="siteLeft" id="siteLeft" style="overflow: auto;">
                    <div v-loading="loading" class="product-card-grid">
                        <div
                            v-for="(p, index) in tableData"
                            :key="p.id || index"
                            class="product-card"
                            :class="{ 'is-active': currentInfo && p.id === currentInfo.id }"
                            @click="changeCurrentInfo(index, p.id)"
                        >
                            <div class="product-card-media">
                                <img v-if="p && p.url" class="product-card-img" :src="resolveUrl(p.url)" />
                                <div v-else class="product-card-img product-card-img--empty"></div>
                            </div>
                            <div class="product-card-body">
                                <h3 class="product-card-title">{{ p.category }}</h3>
                                <div class="product-card-code">
                                    <i class="el-icon-location"></i>
                                    <span class="label">产品编号</span>
                                    <span class="value">{{ p.code }}</span>
                                </div>
                            </div>
                        </div>
                        <div v-if="!loading && !tableData.length" class="product-card-grid--empty">
                            暂无该分类产品
                        </div>
                    </div>
                </div>
        </div>

           <div class="product-layout-right" :key="dataKey">
                <el-card class="box-card">
                    <div class="right" id="mainright" style="overflow: auto;">
                        <div v-if="!loading && !tableData.length" class="product-right-empty">暂无该分类产品</div>
                        <div v-else>
                        <div class="top">
                            <div class="left">
                                <el-carousel :interval="4000" type="card" height="240px" @change="handleCarouselChange">
                                        <el-carousel-item v-for="item in images" :key="item.id">
                                                <img
                                                    class="product-main-img"
                                                    :src="resolveUrl(item.url)"
                                                    style="cursor: zoom-in;"
                                                    loading="lazy"
                                                    decoding="async"
                                                    @click="openImage(item.url)"
                                                />
                                        </el-carousel-item>
                                    </el-carousel>
                                    
                            </div>
                            <div class="right">
                               
                                <p><i style="color:#42b983; margin-top: 10px;"
                                        class="el-icon-location">产品品类</i>&nbsp;&nbsp;&nbsp;{{ currentInfo.category
                                        }}
                                </p>
                                <p><i style="color:#42b983; margin-top: 10px;"
                                        class="el-icon-medal">编码</i>&nbsp;&nbsp;&nbsp;{{currentInfo.code
                                             }}
                                </p>
                                <p><i style="color:#42b983; margin-top: 10px;"
                                        class="el-icon-s-management">面料成分</i>&nbsp;&nbsp;&nbsp;{{ currentInfo.component
                                        }}
                                </p>
                                <p><i style="color:#42b983; margin-top: 10px;"
                                        class="el-icon-s-management">商品尺码</i>&nbsp;&nbsp;&nbsp;{{ currentInfo.size
                                        }}
                                </p>
                                <p><i style="color:#42b983; margin-top: 10px;"
                                        class="el-icon-s-management">产品简介</i>&nbsp;&nbsp;&nbsp;{{ currentInfo.introduction
                                        }}
                                </p>
                                <!-- <img src="../assets/head/advertising.jpg" style="width: 100%;"> -->
                            </div>
                        </div>
                       

                        <div class="bottom">
                            <div class="image-grid" v-if="images && images.length">
                                <div v-for="item in images" :key="item.id" class="image-tile">
                                        <img
                                            class="image-thumb"
                                            :src="resolveUrl(item.url)"
                                            style="cursor: zoom-in;"
                                            loading="lazy"
                                            decoding="async"
                                            @click="openImage(item.url)"
                                        />
                                </div>
                            </div>
                            <div v-else class="image-grid--empty">暂无详情图片</div>
                        </div>
                        </div>


                    </div>
                </el-card>
            </div>
        </div>

        <el-dialog
            title="图片预览"
            :visible.sync="dialogImageVisible"
            width="800px"
            :append-to-body="true"
            :close-on-click-modal="true"
        >
            <div style="display:flex; justify-content:center; align-items:center;">
                <img
                    v-if="dialogImageUrl"
                    :src="dialogImageUrl"
                    alt="preview"
                    style="max-width: 100%; max-height: 70vh; object-fit: contain;"
                />
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {getImageById,getProductById,findByClassfication,getClassfications} from "@/api/product"
export default {
    name: 'site_page',
    data() {
        return {
            loading: false,
            activeIndex: '',
            classfications: [],
            dataKey: 0,
            scrollPosition: 0,
            currentInfo: { },
            images:[],
            tableData: [],
            dataId:{id:1},
            dialogImageVisible: false,
            dialogImageUrl: ''
        }
    },
    computed: {
        apiBase() {
            return process.env.VUE_APP_API_BASE_URL || 'http://localhost:8081'
        }
    },
    methods: {
        openImage(url) {
            this.dialogImageUrl = this.resolveUrl(url)
            this.dialogImageVisible = true
        },
        resolveUrl(u) {
            if (!u) return ''
            // 已是绝对地址就直接用；否则拼到后端域名上
            if (/^https?:\/\//i.test(u)) return u
            // 归一化：避免出现 apiBase 与 url 之间缺少/多余的 `/`
            const base = (this.apiBase || '').replace(/\/$/, '')
            const path = String(u)
                .trim()
                .replace(/\\/g, '/')
                .replace(/^\/+/, '')
            return `${base}/${path}`
        },
        handleCarouselChange(oldIndex, newIndex) {  
        const length = this.images.length
        if (!length) return
        const index = (newIndex + 1) % length
        this.currentInfo.url = this.images[index].url
 
      // 你可以在这里执行任何需要的逻辑
    },
        handleSelect(key) {
            this.activeIndex =key;
            this.load(key);        
      },
        go_to_top() {
            $('#mainright').animate({ scrollTop: 0 }, 1000)
        },
        ToSite(id){
            this.$router.push(`/site?siteId=${id}`)
        },
        async load(classfication) { 
            const input = {'classfication': classfication}
            try { 
            this.loading = true
            const res = await findByClassfication(input)
            this.tableData = (res && res.data) ? res.data : []
            this.currentInfo = this.tableData[0] || {}
            this.dataId.id = this.currentInfo.id || 0
            if (this.dataId.id) {
              const imgRes = await getImageById(this.dataId)
              this.images = (imgRes && imgRes.data) ? imgRes.data : []
            } else {
              this.images = []
            }
            
        } catch (err) {
            console.log(err)
            this.tableData = []
            this.currentInfo = {}
            this.images = []
        } finally {
            this.loading = false
        }
        },
      
        async changeCurrentInfo(index,id) {
            // console.log(id)
            //  await getProductById({id:id}).then((res)=> {
            //     this.currentInfo=res.data[0]
            //  })
            // console.log(index)
            // console.log(this.tableData)
            this.currentInfo=this.tableData[index];

            this.dataId.id = this.currentInfo.id;
            
            await getImageById(this.dataId).then((res) => {
                this.images = res.data
            });
            
        },
    },

    mounted() {
        (async () => {
          try {
            const res = await getClassfications()
            this.classfications = (res && res.data) ? res.data : []
          } catch (e) {
            this.classfications = []
          }
          this.activeIndex = this.classfications[0] || 'polo衫'
          this.load(this.activeIndex)
        })()
    }
};

</script>
<style>
.liked {
    color: red;
}
.el-dialog__body{
    padding: 7px 7px;
}
.site-main {
    height: 100%;
    margin-top: 20px;
}

.product-container {
    display: flex;
    gap: 20px;
    align-items: flex-start;
    margin-top: 15px;
}
.product-layout-left {
    width: 35%;
    display: flex;
    flex-direction: column;
}
.product-layout-right {
    width: 65%;
}

/* 手机端：左右双栏改为上下单栏，提升可用性 */
@media (max-width: 900px){
  .site-main{
    width: min(1100px, 96vw);
    margin: 10px auto 0;
  }
  .product-container {
    flex-direction: column;
  }
  .product-layout-left, .product-layout-right {
    width: 100%;
  }
  /* 左侧列表容器 */
  .siteLeft{
    max-height: 360px;
  }
  .el-menu--horizontal{
    overflow-x: auto;
    white-space: nowrap;
  }
  .product-card-grid{
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }
}

@media (max-width: 600px){
  .siteLeft{
    max-height: 320px;
  }
  .product-card-grid{
    grid-template-columns: 1fr;
  }
  .product-card-title{
    font-size: 15px;
  }
}

.site-card {
    padding: 0px;
    margin-bottom: 10px;
    padding-right: 30px;
}

/* 左侧商品卡片网格（电商展示） */
.product-card-grid{
    padding: 6px;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
    min-height: 360px;
}

.product-card{
    background: #fff;
    border: 1px solid #eee;
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    transition: transform 160ms ease, border-color 160ms ease, box-shadow 160ms ease;
}

.product-card:hover{
    transform: translateY(-2px);
    border-color: rgba(66, 185, 131, 0.55);
    box-shadow: 0 10px 22px rgba(0, 0, 0, 0.08);
}

.product-card.is-active{
    border-color: rgba(66, 185, 131, 0.95);
    box-shadow: 0 10px 22px rgba(66, 185, 131, 0.15);
}

.product-card-media{
    width: 100%;
    aspect-ratio: 1 / 1;
    background: #f6f6f6;
}

.product-card-img{
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.product-card-img--empty{
    background: #f3f3f3;
    width: 100%;
    height: 100%;
}

.product-card-body{
    padding: 10px;
}

.product-card-title{
    margin: 0;
    font-size: 14px;
    line-height: 1.3;
    color: #1f2d3d;
    height: 38px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.product-card-code{
    margin-top: 8px;
    font-size: 12px;
    color: #666;
    display: flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.product-card-code .label{
    color: #42b983;
    font-weight: 600;
}

.product-card-code .value{
    color: #333;
}

.product-card-grid--empty{
    grid-column: 1 / -1;
    padding: 18px 0;
    text-align: center;
    color: #666;
    font-size: 14px;
}

.product-right-empty{
    padding: 20px;
    text-align: center;
    color: #666;
    font-size: 14px;
}

.site-card th {
    border: none;
}

.el-table--border,
.el-table--group {
    border: none;
}

.el-header,
.el-footer {
    background-color: #f2f2f2;
    color: #333;
    text-align: center;
    margin-right: 30px;
    line-height: 60px;
    border-radius: 5px;
}

.el-aside {
    background-color: white;
    color: #333;
    text-align: center;
}
.el-dialog__header {
    padding: 18px 7px 5px;
}
.el-dialog__footer {
    padding: 9px 10px 10px;
    text-align: right;
    box-sizing: border-box;
}
.el-main {
    background-color: white;
    color: #333;
    text-align: center;
}

.desc-img {
    width: 100%;
    padding-left: 0px;
    background-color: lightslategray;
}

.grid-content {
    display: flex;
    align-items: center;
    height: 100px;
}

.grid-cont-right {
    text-align: left;
    padding-left: 10px;
    font-size: 14px;
    color: black;
    /* margin-top: -10px; */
}

.grid-cont-right h2 {
    color: #42b983;
}

.el-scrollbar__bar {
    transition: none;
}

.el-scrollbar:hover>.el-scrollbar__bar {
    transition: none;
}

.el-scrollbar__thumb {
    transition: none;
    transform: none;
}
</style>

<style scoped src="../assets/product.css"></style>
